import { render, staticRenderFns } from "./cart-totals.vue?vue&type=template&id=08930c4c&"
import script from "./cart-totals.vue?vue&type=script&lang=js&"
export * from "./cart-totals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports